<app-add-form
  data-testid="purchase-order-view-form"
  [title]="'purchase_order.view.title' | translate"
  [formFields]="formFields()"
  [tableSections]="tableSections()"
  [headerActions]="headerActions()"
  [loading]="loading()"
  [initialData]="currentFormData"
  [viewMode]="true"
  (formAction)="onFormAction($event.action)"
  (tableAction)="onTableAction($event)"
  (formValueChanges)="onFormValueChanges($event)"
>
  <!-- No actions template needed for view mode -->
</app-add-form>

<!-- Receipt discrepancies (reported by warehouse at receiving time) -->
@if (discrepancies().length > 0) {
  <div class="po-discrepancies" data-testid="po-discrepancies">
    <h3 class="po-discrepancies__title">
      {{ 'purchase_order.view.sections.discrepancies' | translate }}
    </h3>
    <p-table [value]="discrepancies()" [tableStyle]="{ 'min-width': '60rem' }">
      <ng-template pTemplate="header">
        <tr>
          <th>{{ 'purchase_order.view.discrepancies.sku_code' | translate }}</th>
          <th>{{ 'purchase_order.view.discrepancies.expected_qty' | translate }}</th>
          <th>{{ 'purchase_order.view.discrepancies.received_qty' | translate }}</th>
          <th>{{ 'purchase_order.view.discrepancies.discrepancy_qty' | translate }}</th>
          <th>{{ 'purchase_order.view.discrepancies.reason' | translate }}</th>
          <th>{{ 'purchase_order.view.discrepancies.note' | translate }}</th>
          <th>{{ 'purchase_order.view.discrepancies.warrant_code' | translate }}</th>
          <th>{{ 'purchase_order.view.discrepancies.status' | translate }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr>
          <td>{{ row.skuCode }}</td>
          <td class="text-right">{{ row.expectedQty }}</td>
          <td class="text-right">{{ row.receivedQty }}</td>
          <td class="text-right">{{ row.discrepancyQty }}</td>
          <td>{{ row.discrepancyReason }}</td>
          <td>{{ row.discrepancyNote }}</td>
          <td>{{ row.warehouseWarrantCode }}</td>
          <td>{{ row.status }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
}

<!-- Close-short dialog -->
<p-dialog
  data-testid="po-close-short-dialog"
  [visible]="showCloseShortDialog()"
  (visibleChange)="showCloseShortDialog.set($event)"
  [modal]="true"
  [style]="{ width: '30rem' }"
  [header]="'purchase_order.view.close_short.title' | translate"
>
  <p class="mb-3">{{ 'purchase_order.view.close_short.description' | translate }}</p>
  <label class="block mb-1 font-medium" for="close-short-reason">
    {{ 'purchase_order.view.close_short.reason_label' | translate }} *
  </label>
  <textarea
    id="close-short-reason"
    pTextarea
    rows="3"
    class="w-full"
    [(ngModel)]="closeShortReason"
    [placeholder]="'purchase_order.view.close_short.reason_placeholder' | translate"
  ></textarea>
  @if (showCloseShortDialog() && !closeShortReason.trim()) {
    <small class="text-red-500">
      {{ 'purchase_order.view.close_short.reason_required' | translate }}
    </small>
  }
  <ng-template pTemplate="footer">
    <p-button
      [label]="'purchase_order.view.close_short.cancel' | translate"
      severity="secondary"
      [outlined]="true"
      (onClick)="showCloseShortDialog.set(false)"
    />
    <p-button
      [label]="'purchase_order.view.close_short.confirm' | translate"
      severity="warn"
      [loading]="closeShortSubmitting()"
      [disabled]="!closeShortReason.trim()"
      (onClick)="confirmCloseShort()"
    />
  </ng-template>
</p-dialog>

<!-- Toast Messages -->
<p-toast data-testid="purchase-order-view-toast"></p-toast>
